import { render, staticRenderFns } from "./SpeakerResource.vue?vue&type=template&id=3ee32508&"
import script from "./SpeakerResource.vue?vue&type=script&lang=js&"
export * from "./SpeakerResource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports